/**
 * @generated SignedSource<<97d8f1cae29b5f2bb2f4a0e65c786123>>
 * @relayHash c0616cf9960d7113ab6014fe21f8896a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 37db936a62eec41172c4dced33d5e5a905a26b68461f3455c7d8510861e6cec6

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceStaticMacroRenderErrorCode = "INVOCATION_FAILED" | "%future added value";
export type MacroRendererMode = "EDITOR" | "PDF" | "RENDERER" | "%future added value";
export type singleStaticMacroQuery$variables = {
  cloudId: string;
  contentId: string;
  localId: string;
  mode?: MacroRendererMode | null;
};
export type singleStaticMacroQuery$data = {
  readonly confluence_staticMacro: {
    readonly error: {
      readonly code: ConfluenceStaticMacroRenderErrorCode;
    } | null;
    readonly macroId: string;
    readonly value: string | null;
  } | null;
};
export type singleStaticMacroQuery = {
  response: singleStaticMacroQuery$data;
  variables: singleStaticMacroQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "localId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "localId",
        "variableName": "localId"
      },
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      }
    ],
    "concreteType": "ConfluenceStaticMacroRendered",
    "kind": "LinkedField",
    "name": "confluence_staticMacro",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "macroId"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      },
      {
        "concreteType": "ConfluenceStaticMacroRenderError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "code"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "singleStaticMacroQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "singleStaticMacroQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "c0616cf9960d7113ab6014fe21f8896a",
    "id": "37db936a62eec41172c4dced33d5e5a905a26b68461f3455c7d8510861e6cec6",
    "metadata": {},
    "name": "singleStaticMacroQuery",
    "operationKind": "query",
    "text": "query singleStaticMacroQuery($contentId:ID!,$cloudId:ID!,$localId:String!,$mode:MacroRendererMode){confluence_staticMacro(contentId:$contentId,cloudId:$cloudId,localId:$localId,mode:$mode)@optIn(to:[\"AskInCcApiPlatformBeforeUsing\"]){macroId,value,error{code}}}"
  }
};
})();

(node as any).hash = "6003a5beea25a1b3917b2684e24af9de";

export default node;
